import { Form } from 'antd';
import React from 'react';
import { useShutdownResponsible } from '../../../../../shared/api/queries/shutdownResponsible';
import { fieldNames } from '../../../common/config';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';

const responsibleFieldName = fieldNames.responsible;
const companyName = fieldNames.company;
const FormItem = Form.Item;

const ResponsibleField = ({ form }) => {
  const companyId = form.getFieldValue(companyName);

  const { data = [], isFetching } = useShutdownResponsible([companyId], {
    staleTime: Infinity,
  });

  const options = getOptionsBySelect(data, true);

  const isDisabled = Boolean(isFetching || !companyId);

  return (
    <FormItem
      label="Ответственные"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(responsibleFieldName)(
        <DropdownSelect
          options={options}
          disabled={isDisabled}
          loading={isFetching}
          multiple
        />
      )}
    </FormItem>
  );
};

export default ResponsibleField;
